import { MdClose, MdModeEditOutline, MdSave } from "react-icons/md";
import { Grid, Loader, Table } from "semantic-ui-react";
import { InputText } from "../../../../components";
import { InputNumber } from "../../../../components/InputText/InputNumber";

export function renderPackagingRow({
  dataIndex,
  groupIndex,
  index,
  currentRow,
  totalRows,
  rowCount,
  packName,
  gateType,
  label,
  item,
  checkValueIsEmpty,
  editData,
  handleCancel,
  selectPackage,
  register,
  control,
  errors,
  handleSubmit,
  onSubmit,
  isLoadingProcessPackaging,
  isLoadingUpdateFarmGatePackaging,
  isEditable
}: any) {
  const packagingKeyMap: any = {
    "Single Unit Packaging": "singleUnitPackaging",
    "Sales Unit Packaging": "salesUnitPackaging",
    "Bulk Unit Packaging": "bulkUnitPackaging",
    "Transport Unit Packaging": "transportUnitPackaging"
  };
  const groupKey = packagingKeyMap[label];

  const editDataPackaging = (item: any, dataIndex: any, groupKey: any, index: any) => {
    editData(item, dataIndex, groupKey, index);
  };

  return (
    <Table.Row key={`${dataIndex}-${groupIndex}-${index}`}>
      {currentRow === 0 && (
        <Table.Cell rowSpan={totalRows}>
          {packName} ({gateType})
        </Table.Cell>
      )}
      {index === 0 && <Table.Cell rowSpan={rowCount}>{label}</Table.Cell>}
      <Table.Cell className={checkValueIsEmpty(item?.packageName)}>
        {selectPackage ? (
          <InputText
            register={register}
            placeholder="Package Name"
            name={`loadPackagingData.${dataIndex}.${groupKey}.${index}.packageName`}
            errors={errors.loadPackagingData?.[dataIndex]?.[groupKey]?.[index]?.packageName}
            required
            errorMessage="Packaging Name is required"
          />
        ) : (
          <>{item?.packageName || "Missing package name"}</>
        )}
      </Table.Cell>
      <Table.Cell className={checkValueIsEmpty(item?.packageMaterial)}>
        {selectPackage ? (
          <InputNumber
            transform={{
              input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
              output: (e: any) => {
                return e;
              }
            }}
            required
            errors={errors.loadPackagingData?.[dataIndex]?.[groupKey]?.[index]?.packageMaterial}
            control={control}
            placeholder="Package Material"
            name={`loadPackagingData.${dataIndex}.${groupKey}.${index}.packageMaterial`}
            errorMessage="Package Material is required"
          />
        ) : (
          <>{item?.packageMaterial}</>
        )}
      </Table.Cell>
      <Table.Cell className={checkValueIsEmpty(item?.materialWeight)}>
        {selectPackage ? (
          <InputNumber
            transform={{
              input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
              output: (e: any) => {
                return e;
              }
            }}
            required
            control={control}
            errors={errors.loadPackagingData?.[dataIndex]?.[groupKey]?.[index]?.materialWeight}
            placeholder="Material Weight"
            name={`loadPackagingData.${dataIndex}.${groupKey}.${index}.materialWeight`}
            errorMessage="Material Weight is required"
          />
        ) : (
          <>{item?.materialWeight}</>
        )}
      </Table.Cell>
      <Table.Cell>
        {selectPackage ? (
          <InputNumber
            transform={{
              input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
              output: (e: any) => {
                return e;
              }
            }}
            required
            errors={errors.loadPackagingData?.[dataIndex]?.[groupKey]?.[index]?.materialCost}
            control={control}
            placeholder="Material Cost"
            name={`loadPackagingData.${dataIndex}.${groupKey}.${index}.materialCost`}
            errorMessage="Material Cost is required"
          />
        ) : (
          <>{item?.materialCost}</>
        )}
      </Table.Cell>
      <Table.Cell>
        <Grid>
          <Grid.Column computer={4} tablet={5} mobile={5}>
            {(isLoadingProcessPackaging || isLoadingUpdateFarmGatePackaging) && selectPackage ? (
              <Loader active size="small" inline="centered" />
            ) : selectPackage ? (
              <MdSave
                cursor="pointer"
                size={24}
                color="var(--tableEditIcon)"
                title="Save"
                onClick={handleSubmit(onSubmit)}
              />
            ) : (
              <>
                {isEditable && (
                  <MdModeEditOutline
                    cursor="pointer"
                    size={24}
                    color="var(--tableEditIcon)"
                    onClick={() => editDataPackaging(item, dataIndex, groupKey, index)}
                  />
                )}
              </>
            )}

            {/* )} */}
          </Grid.Column>
          {!(isLoadingProcessPackaging || isLoadingUpdateFarmGatePackaging) && selectPackage ? (
            <Grid.Column computer={4} tablet={16} mobile={16}>
              <MdClose
                cursor={"pointer"}
                size={24}
                color="var(--tableEditIcon)"
                onClick={() => handleCancel()}
              />
            </Grid.Column>
          ) : null}
        </Grid>
      </Table.Cell>
    </Table.Row>
  );
}
